/**
 * Sentinel id used in the Services filter group to represent deliverables that
 * have no service line. Real service-line ids are always positive integers from
 * the database, so 0 is safe as a special marker.
 */
export const NO_SERVICE_LINE_FILTER_ID = 0;

/**
 * Filter group keys used by the tasks page sidebar. Centralized so the
 * selector that builds the groups, the helper that applies the filters, and
 * the container that holds the selection signal all reference the same
 * string literals.
 */
export const CXP_TASK_FILTER_KEYS = {
  SERVICE: 'service',
  ACCOUNT: 'account',
} as const;

export type CxpTaskFilterKey = typeof CXP_TASK_FILTER_KEYS[keyof typeof CXP_TASK_FILTER_KEYS];

export interface CxpFilterOption {
  id: number;
  label: string;
  count: number;
}

export interface CxpFilterGroup {
  key: CxpTaskFilterKey;
  label: string;
  options: CxpFilterOption[];
}

export interface CxpFilterChangeEvent {
  groupKey: CxpTaskFilterKey;
  optionId: number;
  selected: boolean;
}

/**
 * Container-owned selection state. Each filter group holds the currently
 * checked option ids. Empty / missing keys mean "no filter applied for this
 * group" (everything passes for that dimension).
 */
export type CxpTaskFilterSelection = Partial<Record<CxpTaskFilterKey, Set<number>>>;
